import { render, staticRenderFns } from "./shipmentContainer.vue?vue&type=template&id=64ae77ac&scoped=true&"
import script from "./shipmentContainer.vue?vue&type=script&lang=js&"
export * from "./shipmentContainer.vue?vue&type=script&lang=js&"
import style0 from "./shipmentContainer.vue?vue&type=style&index=0&id=64ae77ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ae77ac",
  null
  
)

export default component.exports